module.exports = "./img/6dbf98591ab09c356f59a92142355e28.jpg";